/**
 * @file Route related utilities.
 */

import { BASENAME } from '../constants/basenames';

const basenames = [
  BASENAME.PRO,
  BASENAME.CAMPS,
  BASENAME.SCHOOLS,
  BASENAME.SHUTTERBUG,
  BASENAME.GREEK,
  BASENAME.SPORTS,
  BASENAME.CHURCH,
];
const basenamePattern = `:basename(${basenames.join('|')})`;
const shutterbugPattern = `:basename(${BASENAME.SHUTTERBUG})`;

export { basenamePattern, shutterbugPattern };
